<template>
  <ut-form :label-width="200">
    <ut-input placeholder="微信报警组名称" v-show="false" v-model="id" readonly :style="{width:'500px'}"></ut-input>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 名称
      </template>
      <ut-input placeholder="微信报警组名称" v-model="name" :style="{width:'500px'}"></ut-input>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> agentId
      </template>
      <ut-input placeholder="agentId" v-model="agentId" :style="{width:'500px'}"></ut-input>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> corpid
      </template>
      <ut-input placeholder="corpid" v-model="corpid" :style="{width:'500px'}"></ut-input>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> corpsecret
      </template>
      <ut-input placeholder="corpsecret" v-model="corpsecret" :style="{width:'500px'}"></ut-input>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即更新</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data() {
    return {
        name:'',
        agentId:'',
        corpsecret: '',
        corpid: '',
        selected2:'',
        id:''
    }
  },
  methods:{
    submit(){
      var name = this.name;
      var agentId = this.agentId;
      var corpsecret  = this.corpsecret;
      var corpid = this.corpid;
      if(name == ""){
        this.$message.error('微信报警组名称不能为空');
        return false;
      }
      if(agentId == ""){
        this.$message.error('agentid 不能为空');
        return false;
      }
      if (corpsecret == "") {
         this.$message.error('corpsecret 不能为空');
        return false;
      }
      if(corpid == ""){
        this.$message.error('corpid 不能为空');
        return false;
      }
      
      var sendData = {};
      sendData.name = name;
      sendData.agentId = agentId;
      sendData.corpsecret = corpsecret;
      sendData.corpid = corpid;
      sendData.id = this.id;
      this.$http({
        method: "post",
        url: "wechat/update.htm",
        data: JSON.stringify(sendData)
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          if(response.data.code == 0){
            this.$message.success('更新成功');
            this.$router.push({ path: "/wechat" });
          }else{
            this.$message.error(response.data.message);
            return false;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    goBack(){
      this.$router.push({ path: "/wechat" });
    }
  },
  created(){
        console.log(this.$route.query.id)
    // 数据加载
    this.$http({
        method: "post",
        url: "wechat/"+this.$route.query.id+"/get.htm",
        data: "{}"
    }).then(response => {
        //这里使用了ES6的语法
        console.log(response.data)
        this.agentId = response.data.agentId;
        this.corpid = response.data.corpid;
        this.corpsecret = response.data.corpsecret
        this.name = response.data.name
        this.id = response.data.id
    }).catch(error => {
        console.log(error); //请求失败返回的数据
    });
  }
}
</script>